import { SaveOutlined, ReloadOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { duyetLuongBoSungNQL, layLuongBoSungNQL, luuLuongBoSungNQL, tinhLuongBoSungNQL, trinhLuongBoSungNQL, xoaLuongBoSungNQL } from "../../../services/luong";
import { toast } from "react-toastify";
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tabs, Tag } from "antd";
import { currencyFormat, dateCommon, formatVND, parseThangTuMang, validateMessages } from '../../../helpers/common';
import { useDispatch } from 'react-redux';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';
import dayjs from 'dayjs';
import { ContentHeader } from '../../../components';
import ModalTextForm from '../../../components/modal/ModalTextForm';
import { useNavigate } from 'react-router-dom';
import { Links } from '../../../helpers/Links';
import { ChiTietDuocNhanKCT } from '../../../models/luong/ThuLaoKCT';

const { RangePicker } = DatePicker;

var optionsLuongBoSung = [{
    value: 1,
    label: "Theo năm"
},
{
    value: 3,
    label: "Theo tháng"
}];

const LuongBoSungNQL = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [isTinhChiTiet, setIsTinhChiTiet] = useState<boolean>(false);
    const [loaiQuyetToan, setLoaiQuyetToan] = useState<number>(Form.useWatch('loaiBoSung', form));

    const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
    const [showModalTrinh, setShowModalTrinh] = useState<boolean>(false);
    const [showModalDuyet, setShowModalDuyet] = useState<boolean>(false);
    const [chiTietDuocNhan, setChiTietDuocNhan] = useState<Array<ChiTietDuocNhanKCT>>([]);

    const [columnsTable, setColumnTable] = useState<Array<any>>();
    const [dataLuongBoSung, setDataLuongBoSung] = useState<Array<any>>([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const id = Form.useWatch('id', form);
    const loaiBoSung = Form.useWatch('loaiBoSung', form);
    const trangThai = Form.useWatch('trangThai', form);

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            tongLuongQuyetToan: parsedValue,
            tongLuongQuyetToanStr: format
        });
    };

    const eventTrinh = async () => {
        try {
            setShowModalTrinh(false);
            dispatch(showLoadingScreen());
            await trinhLuongBoSungNQL(id);
            navigate(Links.Luong.ThanhToanLuongNQL);
            toast.success("Trình lương quyết toán NQL thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const eventDuyet = async () => {
        try {
            setShowModalDuyet(false);
            dispatch(showLoadingScreen());
            await duyetLuongBoSungNQL(id);
            navigate(Links.Luong.ThanhToanLuongNQL);
            toast.success("Duyệt lương quyết toán NQL thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const eventSaveLuongBoSung = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                var data: any = {
                    id: values.id,
                    ten: values.ten,
                    thangQuyetToan: values.thangQuyetToan,
                    loaiBoSung: values.loaiBoSung,
                    nam: values.kyLuongNam ? values.kyLuongNam.year() : values.kyLuongThang[0].year(),
                    kyLuongThang: values.kyLuongThang,
                    tongLuongQuyetToan: values.tongLuongQuyetToan,
                    isTinhChiTiet: isTinhChiTiet,
                    chiTietDuocNhan: isTinhChiTiet ? chiTietDuocNhan : null
                };

                if ((dataLuongBoSung || []).length > 0) {
                    data.chiTietLuongBoSungNQL = dataLuongBoSung.map(x => {
                        return {
                            idNhanVien: x.idNhanVien,
                            idHeSoLuong: x.idHeSoLuong,
                            tongLuongDuocNhan: x.tongLuongDuocNhan,
                            soTienConDuocNhan: x.soTienConDuocNhan,
                            chiTietDuocNhan: x.chiTietDuocNhan
                        }
                    })
                }

                var response = await luuLuongBoSungNQL(data);
                if (values.id > 0) {
                    loadData(response);
                }
                else {
                    navigate(Links.Luong.ThanhToanLuongNQL)
                }
                toast.success("Lưu quyết toán lương NQL thành công");
            } catch (error: any) {
                toast.error(error);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    }

    const eventDelete = async () => {
        try {
            setShowModalDelete(false);
            dispatch(showLoadingScreen());
            await xoaLuongBoSungNQL(id);
            navigate(Links.Luong.ThanhToanLuongNQL);
            toast.success("Xóa lương quyết toán NQL thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const getById = async (idLQT: any) => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var response = await layLuongBoSungNQL(idLQT);
            loadData(response);
        }
        catch (e: any) {
            toast.error(e)
        }
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const taiDuLieu = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                var data = await tinhLuongBoSungNQL(values.id);
                setDataLuongBoSung(data);
            } catch (e: any) {
                toast.error(e);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    }

    const generateTableColumns = () => {
        var clm: Array<any> = [
            {
                title: "Họ tên",
                dataIndex: 'tenNhanVien',
                key: 'tenNhanVien'
            },
            {
                title: "Chức vụ",
                dataIndex: 'chucVu',
                key: 'chucVu'
            },
            {
                title: "Ngày công hưởng lương",
                dataIndex: 'ngayCongHuongLuong',
                key: 'ngayCongHuongLuong',
                align: 'center'
            },
            {
                title: "Hệ số ngày công",
                dataIndex: 'heSoNgayCong',
                key: 'heSoNgayCong',
                align: 'center'
            },
            {
                title: "Mức lương cơ bản theo chức danh",
                dataIndex: 'mucLuongCB',
                key: 'mucLuongCB',
                className: "custom-column",
                render: (value: any, record: any, index: any) => {
                    return formatVND(record?.mucLuongCB);
                }
            },

        ];

        if (loaiBoSung === 3) {
            clm.push({
                title: "Số tiền được nhận",
                dataIndex: 'tongLuongDuocNhan',
                className: "custom-column",
                key: 'tongLuongDuocNhan',
                render: (value: any, record: any, index: any) => {
                    if (!isEdit || isTinhChiTiet) {
                        return formatVND(record?.tongLuongDuocNhan);
                    } else {
                        return <Input value={record?.tongLuongDuocNhan} onChange={(e: any) => {
                            dataLuongBoSung[index].tongLuongDuocNhan = parseInt(e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''));
                            dataLuongBoSung[index].soTienConDuocNhan = dataLuongBoSung[index].tongLuongDuocNhan - dataLuongBoSung[index].tongLuongDaNhan
                            setDataLuongBoSung([...dataLuongBoSung]);
                        }} />
                    }
                }
            });
            var columnMonths = [];
            if ((dataLuongBoSung || []).length > 0) {
                var months = dataLuongBoSung[0].chiTietDaNhan || [];
                for (var i = 0; i < months.length; i++) {
                    var m = months[i].thang;
                    const idx = i;
                    columnMonths.push({
                        title: m,
                        key: m,
                        className: "custom-column",
                        render: (value: any, record: any) => {
                            return formatVND(record.chiTietDaNhan[idx]?.mucTien || 0);
                        }
                    })
                }
            };

            var columnMonthsDaNhan = [];
            if ((dataLuongBoSung || []).length > 0 && isTinhChiTiet) {
                var months = dataLuongBoSung[0].chiTietDuocNhan || [];
                if (months.length > 0) {                    
                    for (var i = 0; i < months.length; i++) {
                        var m = months[i];
                        const idx = i;
                        columnMonthsDaNhan.push({
                            title: m.ten,
                            key: m.ten + i.toString(),
                            className: "custom-column",
                            render: (value: any, record: any, index: number) => {                                
                                if (!isEdit) {
                                    return formatVND(record.chiTietDuocNhan[idx].mucTien || 0);
                                }
                                else {
                                    return <Input value={record.chiTietDuocNhan[idx].mucTien} onChange={(e: any) => {
                                        var v = parseInt(e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''));
                                        var chenhLech = v - record.chiTietDuocNhan[idx].mucTien;
    
                                        dataLuongBoSung[index].chiTietDuocNhan[idx].mucTien = v;
                                        dataLuongBoSung[index].soTienConDuocNhan = dataLuongBoSung[index].soTienConDuocNhan + chenhLech
                                        dataLuongBoSung[index].tongLuongDuocNhan = dataLuongBoSung[index].tongLuongDuocNhan + chenhLech
                                        setDataLuongBoSung([...dataLuongBoSung]);
                                    }} />
                                }
                            }
                        })
                    }
                    clm.push({
                        title: "Lương được nhận",
                        children: columnMonthsDaNhan
                    });
                }                
            }
            columnMonths.push({
                title: "Tổng cộng",
                key: "luongdanhan",
                className: "custom-column",
                render: (value: any, record: any) => {
                    return formatVND(record.tongLuongDaNhan);
                }
            });
            clm.push({
                title: "Lương đã nhận",
                children: columnMonths
            });
        } else {
            clm.push({
                title: "Mức lương cơ bản theo chức danh cả năm",
                key: "mucLuongCBCaNam",
                className: "custom-column",
                render: (value: any, record: any) => {
                    return formatVND(record.mucLuongCBCaNam);
                }
            });
            clm.push({
                title: "Số tiền được nhận",
                dataIndex: 'tongLuongDuocNhan',
                className: "custom-column",
                key: 'tongLuongDuocNhan',
                render: (value: any, record: any, index: any) => {
                    if (!isEdit) {
                        return formatVND(record?.tongLuongDuocNhan);
                    } else {
                        return <Input value={record?.tongLuongDuocNhan} onChange={(e: any) => {
                            dataLuongBoSung[index].tongLuongDuocNhan = parseInt(e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, ''));
                            dataLuongBoSung[index].soTienConDuocNhan = dataLuongBoSung[index].tongLuongDuocNhan - dataLuongBoSung[index].tongLuongDaNhan
                            setDataLuongBoSung([...dataLuongBoSung]);
                        }} />
                    }
                }
            });
            clm.push({
                title: "Lương đã nhận",
                key: "luongdanhan",
                className: "custom-column",
                render: (value: any, record: any) => {
                    return formatVND(record.tongLuongDaNhan);
                }
            });
        }

        clm.push({
            title: "Số tiền còn được nhận",
            key: "soTienConDuocNhan",
            className: "custom-column",
            render: (value: any, record: any, index: any) => {
                return formatVND(record?.soTienConDuocNhan)
            }
        })

        setColumnTable(clm);
    }

    const loadData = (response: any) => {
        var format = currencyFormat.formatMoney(response.tongLuongQuyetToan + "");
        var chiTietDuocNhanResponse = response.luongBoSung[0]?.chiTietDuocNhan
        if (chiTietDuocNhanResponse == null && chiTietDuocNhanResponse == undefined) {            
            setChiTietDuocNhan(response.chiTietDuocNhan);            
        }
        else {
            setChiTietDuocNhan(chiTietDuocNhanResponse)
        }
        var dform: any = {
            id: response.id,
            ten: response.ten,
            thangQuyetToan: dayjs(response.thangQuyetToan),
            loaiBoSung: response.loaiBoSung,
            kyLuongNam: dayjs(new Date(response.nam, 1, 1)),
            tongLuongQuyetToan: response.tongLuongQuyetToan + "",
            tongLuongQuyetToanStr: format,
            trangThai: response.trangThai,
            isTinhChiTiet: response.isTinhChiTiet,
            kyLuongThang: (chiTietDuocNhanResponse != null && chiTietDuocNhanResponse != undefined) ? [dayjs(dateCommon.formatDate(new Date(response?.nam, chiTietDuocNhanResponse[0]?.thang - 1, 1)), "DD/MM/YYYY"), dayjs(dateCommon.formatDate(new Date(response?.nam, chiTietDuocNhanResponse[chiTietDuocNhanResponse?.length - 1]?.thang - 1, 1)), "DD/MM/YYYY")] :
                undefined,
        };

        if (dform.loaiBoSung === 3) {
            dform.kyLuongThang = [dayjs(response.kyLuongThang[0]), dayjs(response.kyLuongThang[1])]
        }

        form.setFieldsValue(dform);
        setIsEdit(false);
        setLoaiQuyetToan(response.loaiBoSung);
        setIsTinhChiTiet(response.isTinhChiTiet);        
        setDataLuongBoSung(response.luongBoSung);
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let idLQT = +(params.get('id') || '');
        if (idLQT) {
            getById(idLQT);
        }
    }, [])

    useEffect(() => {
        generateTableColumns();
    }, [dataLuongBoSung, isEdit])

    return <section>
        {showModalDelete && <ModalTextForm show
            title="Xoá quyết toán lương"
            handleClose={() => setShowModalDelete(false)}
            handleSave={eventDelete}>
            Xác nhận xóa quyết toán lương người quản lý
        </ModalTextForm>}
        {showModalTrinh && <ModalTextForm show
            title="Trình quyết toán lương"
            handleClose={() => setShowModalTrinh(false)}
            handleSave={eventTrinh}>
            Xác nhận trình quyết toán lương người quản lý
        </ModalTextForm>}
        {showModalDuyet && <ModalTextForm show
            title="Duyệt quyết toán lương"
            handleClose={() => setShowModalDuyet(false)}
            handleSave={eventDuyet}>
            Xác nhận duyệt quyết toán lương người quản lý
        </ModalTextForm>}
        <ContentHeader title="Quyết toán lương Người quản lý" />
        <Tabs
            tabBarExtraContent={
                <Space>
                    {
                        id > 0 && trangThai == 0 &&
                        <Button
                            type="primary" danger
                            icon=<DeleteOutlined rev="" />
                            onClick={() => { setShowModalDelete(true) }}
                        >
                            Xóa
                        </Button>
                    }
                    {
                        id > 0 && trangThai == 0 &&
                        <Button
                            type="primary"
                            icon=<SaveOutlined rev="" />
                            onClick={() => { setShowModalTrinh(true) }}
                        >
                            Trình phê duyệt
                        </Button>
                    }
                    {
                        trangThai == 2 &&
                        <Button
                            type="primary"
                            icon=<SaveOutlined rev="" />
                            onClick={() => { setShowModalDuyet(true) }}
                        >
                            Duyệt
                        </Button>
                    }
                    {
                        (trangThai == 0 || trangThai == undefined) &&
                        <Button
                            type="primary"
                            icon={<SaveOutlined rev="" />}
                            onClick={eventSaveLuongBoSung}
                        >
                            Lưu
                        </Button>
                    }

                </Space>}
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: "Quyết toán lương",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    form={form}
                                >
                                    <Row gutter={12}>
                                        <Col span="12" >
                                            <Form.Item hidden name="id"><Input /></Form.Item>
                                            <Form.Item hidden name="trangThai"><Input /></Form.Item>
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Tên kỳ quyết toán lương" name="ten">
                                                <Input readOnly={trangThai > 0} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={loaiQuyetToan >= 2 ? "4" : "6"}>
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Loại quyết toán" name="loaiBoSung">
                                                <Select notFoundContent="Không có dữ liệu" disabled={trangThai > 0 || (id > 0 && isTinhChiTiet)}
                                                    options={optionsLuongBoSung}
                                                    loading={isLoading}
                                                    onChange={(e) => {
                                                        setLoaiQuyetToan(e);
                                                        if (e > 1) {
                                                            setIsTinhChiTiet(false);
                                                            form.setFieldsValue({ 'isTinhChiTiet': false });
                                                        }
                                                    }}
                                                    placeholder="Loại quyết toán" />
                                            </Form.Item>
                                        </Col>
                                        {
                                            (loaiQuyetToan >= 2) && <Col span="2">
                                                <Form.Item valuePropName="checked" name="isTinhChiTiet" label="Tính chi tiết">
                                                    <Checkbox disabled={id > 0} onChange={(e) => setIsTinhChiTiet(e.target.checked)} />
                                                </Form.Item>
                                            </Col>
                                        }
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: loaiBoSung === 1 ? true : false
                                                },
                                            ]} label="Kỳ quyết toán" name="kyLuongNam" hidden={loaiBoSung != 1}>
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={trangThai > 0}
                                                    style={{ width: "100%" }}
                                                    format="YYYY"
                                                    placeholder="Chọn năm quyết toán"
                                                    picker="year" />
                                            </Form.Item>
                                            <Form.Item rules={[
                                                {
                                                    required: loaiBoSung === 3 ? true : false
                                                },
                                            ]} label="Kỳ quyết toán" name="kyLuongThang" hidden={loaiBoSung != 3}>
                                                <RangePicker disabled={trangThai > 0 || (id > 0 && isTinhChiTiet)}
                                                    changeOnBlur={true}
                                                    placeholder={["Từ tháng", "Đến tháng"]}
                                                    picker="month"
                                                    format="[Tháng] MM"
                                                    style={{ width: "100%" }}
                                                    onChange={(value, string) => {
                                                        let chiTietDuocNhanList = parseThangTuMang(string).map((item) =>
                                                            new ChiTietDuocNhanKCT(
                                                                item
                                                            ))
                                                        setChiTietDuocNhan(chiTietDuocNhanList);
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>
                                        {chiTietDuocNhan?.length > 0 && isTinhChiTiet && chiTietDuocNhan.map((item, index) => (
                                            < Col span={loaiQuyetToan === 0 ? "4" : "6"} key={item.thoiGian + index.toString()}>
                                                <label>Quỹ thù lao {item.ten}</label>
                                                <Input prefix="₫ " disabled={id > 0 && isTinhChiTiet}
                                                    value={chiTietDuocNhan[index].quyThuLaoThangStr}
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
                                                        var format = currencyFormat.formatMoney(parsedValue);
                                                        chiTietDuocNhan[index].quyThuLaoThang = parseInt(parsedValue);
                                                        chiTietDuocNhan[index].quyThuLaoThangStr = format;
                                                        setChiTietDuocNhan([...chiTietDuocNhan]);
                                                    }}
                                                />
                                                <Input hidden value={chiTietDuocNhan[index].quyThuLaoThang} />
                                            </Col>))}
                                    </Row>
                                    <Row gutter={12}>
                                        {!isTinhChiTiet && <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label="Quỹ lương quyết toán" name="tongLuongQuyetToanStr">
                                                <Input prefix="₫ " readOnly={trangThai > 0}
                                                    onChange={handleChangeCurrency}
                                                />
                                            </Form.Item>
                                            <Form.Item hidden name="tongLuongQuyetToan" >
                                                <Input />
                                            </Form.Item>
                                        </Col>}
                                        <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                },
                                            ]} label="Tháng chi trả" name="thangQuyetToan" >
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={trangThai > 0}
                                                    picker="month"
                                                    style={{ width: "100%" }}
                                                    placeholder="Chọn tháng"
                                                    format={["MM/YYYY", "MMYYYY"]}
                                                    allowClear={false}
                                                />
                                            </Form.Item>

                                        </Col>
                                        {
                                            id &&
                                            <Col span="6">
                                                <Form.Item label="Trạng thái">
                                                    {
                                                        trangThai == 0 &&
                                                        <Tag color="processing">Khởi tạo</Tag>
                                                    }
                                                    {
                                                        trangThai == 1 &&
                                                        <Tag color="success">Đã duyệt</Tag>
                                                    }
                                                    {
                                                        trangThai == 2 &&
                                                        <Tag color="warning">Trình duyệt</Tag>
                                                    }
                                                </Form.Item>
                                            </Col>
                                        }

                                    </Row>
                                    {
                                        id && trangThai == 0 &&
                                        <Row>
                                            <Space>
                                                <Button
                                                    onClick={taiDuLieu}
                                                    type="primary"
                                                    loading={isLoading}
                                                    icon={<ReloadOutlined rev="" />}>
                                                    Tải dữ liệu tính lương bổ sung
                                                </Button>
                                            </Space>
                                        </Row>
                                    }
                                </Form>
                            </Col>
                        </Row>
                }]} />
        {id > 0 && trangThai == 0 &&
            <Row>
                <Col span="24">
                    <Space className="float-right">
                        <Button
                            type="default"
                            icon={<EditOutlined rev="" />}
                            onClick={() => {
                                setIsEdit(!isEdit);
                            }}
                        >
                            {
                                !isEdit ? "Chỉnh sửa" : "Khóa"
                            }
                        </Button></Space>
                </Col>
            </Row>
        }
        {
            id > 0 &&
            <div className="card card-primary mt-2">
                <Table
                    scroll={{ x: 2000 }}
                    columns={columnsTable}
                    loading={isLoading}
                    dataSource={(dataLuongBoSung || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                    locale={{ emptyText: "Không có dữ liệu" }}
                    pagination={false}
                    bordered={true}
                    sticky
                    summary={pageData => {
                        let totalTongLuongDuocNhan = 0;
                        let totaltongLuongDaNhan = 0;
                        let totalSoTienConDuocNhan = 0;
                        pageData.forEach(({ tongLuongDuocNhan, tongLuongDaNhan, soTienConDuocNhan, luongThemGio }) => {
                            totalTongLuongDuocNhan += tongLuongDuocNhan;
                            totaltongLuongDaNhan += tongLuongDaNhan;
                            totalSoTienConDuocNhan += soTienConDuocNhan;
                        });
                        var thang = 0;
                        if ((pageData || []).length > 0) {
                            thang = (pageData[0].chiTietDaNhan || []).length;
                        }
                        return (
                            <>
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={1} colSpan={2} align="center"> <label>Tổng cộng</label> </Table.Summary.Cell>
                                    <Table.Summary.Cell index={2}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={3}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={4}></Table.Summary.Cell>
                                    {
                                        thang == 0 &&
                                        <Table.Summary.Cell index={8} colSpan={1}></Table.Summary.Cell>
                                    }
                                    <Table.Summary.Cell index={5} align="right"> <label>{formatVND(totalTongLuongDuocNhan)} </label> </Table.Summary.Cell>
                                    {
                                        thang > 0 && (isTinhChiTiet && chiTietDuocNhan != null) ?
                                            <Table.Summary.Cell index={6} colSpan={thang + chiTietDuocNhan.length}></Table.Summary.Cell> : 
                                            <Table.Summary.Cell index={6} colSpan={thang}></Table.Summary.Cell>
                                    }
                                    <Table.Summary.Cell index={5} align="right"> <label>{formatVND(totaltongLuongDaNhan)} </label> </Table.Summary.Cell>
                                    <Table.Summary.Cell index={7} align="right"> <label>{formatVND(totalSoTienConDuocNhan)} </label> </Table.Summary.Cell>
                                </Table.Summary.Row>
                            </>
                        );
                    }}
                >
                </Table>
            </div>
        }
    </section >
}

export default LuongBoSungNQL;